<template>
  <el-dialog title="Upload Files" center :visible.sync="dialogVisible" :before-close="handleClose" class="tableBox" :append-to-body="true">
      <el-col :span="24" style="padding-bottom: 50px" v-loading="loadingDialog">
        <div class="adapt-top">
          <el-form ref="formref" class="formShow">
            <el-upload
              ref="upload"
              :action="uploadUrl"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              :show-file-list="true"
              :data="formData"
              :auto-upload="false"
              :file-list="fileList"
              :disabled="chooseLoad"
              name="file"
              accept=".doc, .docx">
              <el-button slot="trigger" size="small" type="primary" :disabled="chooseLoad">选取文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传文件</el-button>
            </el-upload>
          </el-form>
          <p class="noteText">*上传文件最大不超过50M，支持的格式为doc,docx</p>
        </div>
      </el-col>
    </el-dialog>
</template>
<script>
import util from '@/util/util.js'
export default {
  name: "el-import",
  props:['roleInfo'],
  data() {
    return {
      dialogVisible: false,
      loadingDialog:false,
      chooseLoad:false,
      uploadUrl: this.baseSSO.upload_file_url,
      dataFileResp:[],
      formData:{},
      fileList: [],
    }
  },
  mounted(){

  },
  created(){
    this.formData = util.getUploadSignatureFormData(null);
    let that = this;
    const timer = setInterval(() =>{
      this.formData = util.getUploadSignatureFormData(null);
      console.info("刷新签名");
      console.info(that.formData);
    }, 60000);
    this.$once('hook:beforeDestroy', () => {
        clearInterval(timer);
    })
  },
  methods: {
    handleClose(done){
      this.$refs.upload.clearFiles()
      this.resetDialog()
      this.chooseLoad = false
      done()
    },
    //点击上传
    submitUpload(){
      if(this.fileList.length > 0){
        this.chooseLoad = true
        this.$refs.upload.submit();
      }
    },
    resetDialog(){
      this.dataFileResp = []
      this.fileList = []
    },
    creadData(response, file, fileList){
      // console.log(response, file, fileList)
      this.dialogVisible = false
      this.chooseLoad = false
      this.$refs.upload.clearFiles()
      this.resetDialog()   //清空文件

      // console.log(this.roleInfo,'=============mmm')
      //把file id传给后台
      /**  */
      let url =this.baseAcsUrl + '/acs/user-system-operation-guide'
      let obj = {
        fileId:response.fileId,
        fileName:file.name,
        roleId:this.roleInfo.id,
        roleName:this.roleInfo.role_name
      }
      this.http.post(url,obj).then(res=>{
        // console.log(res,'===========>')
        if(res.status == 200){
          this.$message.success('上传成功')
        }
      })
     
    },
    //上传文件服务器成功
    handleSuccess(response, file, fileList) {
      this.dataFileResp = []
      console.log(response,file,fileList,'handleSuccess')
      this.creadData(response, file, fileList)
      this.dataFileResp.push(response,file,fileList)
    },
    //
    handleError(err, file, fileList) {
       this.$refs.upload.clearFiles()        
       this.$message.error('上传失败')
       this.chooseLoad = false
    },
    //移出文件
    handleRemove(){
      this.chooseLoad = false
      console.log('handleRemove')
    },
    //选择文件
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
      console.log(this.fileList,'handleChange')
    },
    //上传之前的大小限制，格式限制
    handleBeforeUpload(file) {
      console.log(file,'handleBeforeUpload')
      //不能超过50M
      if (file.size > 50 * 1024 * 1024) {
        this.$message.warning('file exceeds size limit');
        return false;
      }
      let name = file.name
      let index = name.lastIndexOf('.')+1
      let type = name.substring(index)
      if(type=='doc'||type=='docx'){
        //nothing
      }else {
        this.$message.warning('can only upload doc or docx file');
        return false;
      }
    },
  },
  // watch: {
  //   value(){
  //     this.valueId = this.value
  //     this.initHandle()
  //   }
  // },
};
</script>
<style scoped>
.demo-ruleForm /deep/ .el-form-item{
  margin-bottom: 25px!important;
}
.tableBox /deep/ .el-table td,.tableBox /deep/ .el-table th{
  padding: 6px 0;
}
.tableBox /deep/ .el-dialog{
  width: 40%;
}
.tableBox /deep/ .el-dialog__body{
  min-height: 250px;
}
.formShow{
}
.adapt-top{
  position: relative;
  text-align: center;
  margin-top: 50px;
  padding-bottom: 50px;
}
.adapt-top .noteText{
  font-size: 12px;
    color: #f56c6c;
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
}
.adapt-top /deep/ .el-upload-list{
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/importComponent/upload_user_guide.vue